<template>
  <div class="property-form-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu" />
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/property/list' }">
        <app-i18n code="entities.property.menu" />
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.property.edit.title" v-if="isEditing" />
        <app-i18n code="entities.property.new.title" v-if="!isEditing" />
      </el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Back Button -->
    <app-back-button route-name="propertyList" :i18nCode="`entities.property.label`" />

    <!-- Title -->
    <h1 class="app-content-title app-content-title--hidden">
      <app-i18n code="entities.property.edit.title" v-if="isEditing" />
      <app-i18n code="entities.property.new.title" v-if="!isEditing" />
    </h1>

    <!-- Content -->
    <div class="app-content-page">
      <div class="app-page-spinner" v-if="!model || findLoading" v-loading="!model || findLoading" />

      <el-form 
        v-loading="saveLoading"
        v-if="model"
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
      >
        <!-- Subtitle -->
        <h2 class="app-content-subtitle">
          <app-i18n code="entities.property.form.subtitle.information" />
        </h2>
        
        <!-- ********* -->
        <!-- Section 1 -->
        <!-- ********* -->
        <el-row :gutter="10">
          <!-- Logos -->
          <el-col :lg="5" :md="8" :sm="24">
            <el-form-item :prop="fields.logos.name" :required="fields.logos.required">
              <app-image-upload
                v-model="model[fields.logos.name]"
                :max="fields.logos.max"
                :path="fields.logos.path(propertyId)"
                :placeholder="i18n('entities.property.placeholders.uploadFile')"
                :schema="fields.logos.fileSchema"
              />
            </el-form-item>
          </el-col>

          <!-- Property Info -->
          <el-col :lg="19" :md="16" :sm="24">
            <el-row :gutter="10">
              <!-- Name -->
              <el-col :lg="24" :md="24" :sm="24">
                <el-form-item
                  :label="fields.name.label"
                  :prop="fields.name.name"
                  :required="fields.name.required"
                >
                  <el-input
                    v-model="model[fields.name.name]"
                    prefix-icon="icon-cup"
                    :placeholder="i18n('entities.property.placeholders.name')"
                    ref="focus"
                  />
                </el-form-item>
              </el-col>

              <!-- Sport -->
              <el-col :lg="12" :md="12" :sm="24">
                <el-form-item
                  :label="fields.sport.label"
                  :prop="fields.sport.name"
                  :required="fields.sport.required"
                >
                  <el-select
                    v-model="model[fields.sport.name]"
                    :disabled="isEditing"
                    :placeholder="i18n('entities.property.placeholders.sport')"
                  >
                    <!-- TODO: paquete1: cambiar el icono de sport -->
                    <i class="icon-dartboard" slot="prefix"></i>
                    <el-option
                      :key="option.id"
                      :label="option.label"
                      :value="option.id"
                      v-for="option in fields.sport.options"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- Type -->
              <el-col :lg="12" :md="12" :sm="24">
                <el-form-item
                  :label="fields.type.label"
                  :prop="fields.type.name"
                  :required="fields.type.required"
                >
                  <el-select
                    v-model="model[fields.type.name]"
                    :disabled="disabledType || isEditing"
                    :key="model[fields.sport.name]"
                    :placeholder="i18n('entities.property.placeholders.type')"
                  >
                    <i class="icon-cup" slot="prefix"></i>
                    <el-option
                      :key="option.id"
                      :label="option.label"
                      :value="option.id"
                      v-for="option in propertyTypeOptionsPerSport"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>


        <!-- Separator -->
        <div class="app-content-separator" />

        <!-- Subtitle -->
        <h2 class="app-content-subtitle property-form-page__subtitle__management">
          <app-i18n code="entities.property.form.subtitle.management" />
        </h2>

        <!-- Description -->
        <h3 class="app-content-description property-form-page__description__email">
          <app-i18n code="entities.property.form.description.email" />
        </h3>
        
        <!-- ********* -->
        <!-- Section 3 -->
        <!-- ********* -->
        <el-row :gutter="10">
          <!-- Emails -->
          <el-col :lg="18" :md="18" :sm="24">
            <el-form-item
              :label="fields.emails.label"
              :prop="fields.emails.name"
              :required="fields.emails.required"
            >
              <emails-input
                v-model="model[fields.emails.name]"
                prefix-icon="icon-mail"
                :placeholder="i18n('entities.property.placeholders.email')"
              >
              </emails-input>
            </el-form-item>
          </el-col>

          <!-- Access -->
          <!-- <el-col :lg="6" :md="6" :sm="24">
            <el-form-item
              :label="fields.access.label"
              :prop="fields.access.name"
              :required="fields.access.required"
            >
              <el-select
                :placeholder="i18n('entities.property.placeholders.access')"
                v-model="model[fields.access.name]"
              >
                <i class="icon-lock" slot="prefix"></i>
                <el-option
                  :key="option.id"
                  :label="option.label"
                  :value="option.id"
                  v-for="option in fields.access.options"
                />
              </el-select>
            </el-form-item>
          </el-col> -->

          <!-- Status -->
          <!-- <el-col :lg="6" :md="6" :sm="6">
            <el-form-item
              :label="fields.status.label"
              :prop="fields.status.name"
              :required="fields.status.required"
              v-if="isEditing"
            >
              <el-select :placeholder="fields.status.label" v-model="model[fields.status.name]">
                <i :class="prefixStatus" slot="prefix"></i>
                <el-option
                  :key="option.id"
                  :label="option.label"
                  :value="option.id"
                  v-for="option in fields.status.options"
                />
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>

        <!-- Separator -->
        <div v-if="showProperties" class="app-content-separator" />

        <!-- Subtitle -->
        <h2 v-if="showProperties" class="app-content-subtitle">
          <app-i18n code="entities.property.form.subtitle.subproperties" />
        </h2>
        
        <!-- ********* -->
        <!-- Section 4-->
        <!-- ********* -->
        <el-row :gutter="10">
          <!-- Max Num Subproperty -->
          <el-col :lg="7" :md="7" :sm="24">
            <el-form-item
              v-if="showProperties"
              :label="fields.maxNumSubproperty.label"
              :prop="fields.maxNumSubproperty.name"
              :required="fields.maxNumSubproperty.required"
            >
              <el-select
                :placeholder="fields.maxNumSubproperty.label"
                v-model="model[fields.maxNumSubproperty.name]"
              >
                <i class="icon-album" slot="prefix"></i>
                <el-option
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                  v-for="option in maxNumbersOptions"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Separator -->
        <div v-if="showCountry" class="app-content-separator" />

        <!-- Subtitle -->
        <h2 v-if="showCountry" class="app-content-subtitle">
          <app-i18n code="entities.property.form.subtitle.country" />
        </h2>
        <!-- ********* -->
        <!-- Section 2 -->
        <!-- ********* -->
        <!-- Separator -->
        <el-row :gutter="10">

        <!-- Country -->
          <el-col :lg="10" :md="10" :sm="24">
            <el-form-item
              v-if="showCountry"
              :label="fields.country.label"
              :prop="fields.country.name"
              :required="fields.country.required"
            >
              <el-select 
                :disabled="isEditing"
                :placeholder="i18n('entities.property.placeholders.country')"
                :no-match-text="i18n('entities.property.placeholders.noData')"
                v-model="model[fields.country.name]"
                filterable
              >
                <i class="icon-location" slot="prefix"></i>
                <el-option
                  :key="option.id"
                  :label="option.label"
                  :value="option.id"
                  v-for="option in countries"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        

        <!-- Subproperty -->
        <el-row :gutter="10"
          v-if="isMonoSubproperty"
        >
          <el-col :lg="24" :md="24" :sm="24">
            <app-subproperty-input 
              :subproperty.sync="model[fields.subproperty.name]"
              :isPropertyNBA="isTypeNBA"
              :isMonoSubproperty="isMonoSubproperty"  
              ref="subpropertyForm" 
            />
          </el-col>
        </el-row>
        
        <!-- Form controls -->
          <el-form-item>
            <div class="property-form-page__form-buttons form-buttons">
              <router-link :to="{name: 'propertyList'}">
                <el-button type="secondary">
                  <app-i18n code="common.back.default" />
                </el-button>
              </router-link>

              <el-button
                class="right"
                :disabled="saveLoading"
                @click="doSubmit"
                type="primary"
              >
                <app-i18n v-if="!isEditing" code="common.create" />
                <app-i18n v-if="isEditing" code="common.save" />
              </el-button>
            </div>
          </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { PropertyModel } from '@modules/property/property-model';
import SubpropertyInput from '@modules/subproperty/components/subproperty-input';
import { i18n } from '@shared/i18n';
import { getPropertyTypeListBySport } from '@shared/factories/enums-factory';

import country from '@enums/country.json';

import { get } from 'lodash';
const { fields } = PropertyModel;

const formSchema = new FormSchema([
  fields.id,
  fields.name,
  fields.emails,
  fields.sport,
  fields.country,
  fields.status,
  fields.access,
  fields.logos,
  fields.type,
  fields.managers,
  fields.maxNumSubproperty,
  fields.subproperty,
]);

export default {
  name: 'app-property-form-page',

  props: {
    id: String,
    navigateOnSubmit: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      propertyId: null,
      rules: formSchema.rules(),
      model: null,
      maxNumbersOptions: [
        { value: 1, label: '1' },
        { value: 5, label: '5' },
        { value: 10, label: '10' },
        { value: 15, label: '15' },
      ],
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'property/form/record',
      findLoading: 'property/form/findLoading',
      saveLoading: 'property/form/saveLoading',
    }),
    isEditing() {
      return !!this.id;
    },
    isMonoSubproperty() {
      return (
        this.model[fields.maxNumSubproperty.name] === 1
      );
    },
    isTypeNBA() {
      return get(this, 'model.type', null) === 'nba';
    },
    showCountry() {
      return this.isMonoSubproperty || this.isTypeNBA;
    },
    showProperties() {
      return !this.isTypeNBA && !this.isEditing
    },
    disabledType() {
      return (
        this.model.sport === undefined ||
        this.model.sport === null
      );
    },
    fields() {
      return fields;
    },
    countries() {
      return this.fields.country.options.filter(
        ({ id }) => {
          return country.some(
            (countryId) => countryId === id,
          ); 
        }, 
      ); 
    }, 
    propertyTypeOptionsPerSport() {

      const sport = this.model.sport;
      const propertyTypeListBySport = getPropertyTypeListBySport(sport);

      const options = this.fields.type.options;
      var optionsFiltered = [];

      optionsFiltered = options.filter(({ id }) =>
        propertyTypeListBySport.some((item) => item === id),
      );

      return optionsFiltered;
    },
    prefixStatus() {
      var status = '';
      if (this.model.status === 'enabled')
        return (status = 'icon-accept');
      if (this.model.status === 'disabled')
        return (status = 'icon-quit');
      return status;
    },
  },

  async created() {
    if (this.isEditing) {
      this.propertyId = this.id;
      await this.doFind(this.id);
    } else {
      this.propertyId = await this.doGetNewId();
      await this.doNew();
    }

    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doGetNewId: 'property/form/doGetNewId',
      doFind: 'property/form/doFind',
      doNew: 'property/form/doNew',
      doUpdate: 'property/form/doUpdate',
      doCreate: 'property/form/doCreate',
    }),

        async doValidation() {
      try {
        const {
          form,
          subpropertyForm,
        } = this.$refs;
        const forms = [];

        if (form) forms.push(form);

        if (subpropertyForm) {
          forms.push(subpropertyForm.$refs.form);
        }

        await Promise.all(
          forms.map((form) => {
            form.clearValidate();
            return form.validate();
          }),
        );
        return; //
      } catch (error) {
        throw error;
      }
    },

    doReset() {
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      try {
        await this.doValidation();

      } catch (error) {
        return;
      }

      const { isMonoSubproperty } = this
      const { id, ...values } = formSchema.cast(this.model);

      if (isMonoSubproperty ) {
        const { name, logos, country} = values; 
        this.model.subproperty.name = name;
        this.model.subproperty.logo = logos;
        this.model.subproperty.country = country;
      }

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
          navigateOnSubmit: this.navigateOnSubmit,
        });
      } else {
        return this.doCreate({
          id: this.propertyId,
          values,
        });
      }
    },

    i18n(code) {
      return i18n(code);
    },
  },

  watch: {
    'model.sport'() {
      if (!this.isEditing) {
        this.model.type = null;
      }
    },
  },

  components: {
    [SubpropertyInput.name]: SubpropertyInput,
  },
};
</script>

<style lang="scss" scoped>
.property-form-page {
  &__subtitle__management {
    margin: 0;
  }
  &__description__email {
    margin-top: 16px;
    margin-bottom: 32px;
  }
}
</style>
